import { render } from "./areaTeaZcEchart.vue?vue&type=template&id=236ef549&scoped=true"
import script from "./areaTeaZcEchart.vue?vue&type=script&lang=js"
export * from "./areaTeaZcEchart.vue?vue&type=script&lang=js"

import "./areaTeaZcEchart.vue?vue&type=style&index=0&id=236ef549&scoped=true&lang=scss"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236ef549"]])

export default __exports__